import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";

const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 5;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiSelect({ label, data, items, handleChange }) {
  
  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <p className="text-sm text-blanco font-semibold ml-2 mb-[0.5px]">
          {label}
        </p>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={items}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                maxHeight: 48,
                overflowY: "auto",
              }}
            >
              {selected.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  sx={{
                    color: "#fff",
                    backgroundColor: "#cb9636",
                    fontSize: "10px",
                    height: "18px",
                    marginTop: "5px",
                  }}
                />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
          className="rounded-lg block w-full bg-inputs h-auto"
          sx={{
            color: "#fffcfc",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "transparent",
            },
          }}
        >
          {/* Opción "TODOS" */}
          <MenuItem
            value="TODOS"
            sx={{
              fontSize: "10px",
              backgroundColor: "#484d50", // color base
              "&:hover": {
                backgroundColor: "#484d50", // sin cambio en hover
              },
              "&.Mui-selected": {
                backgroundColor: "#484d50", // sin color de selección
              },
              "&.Mui-selected:hover": {
                backgroundColor: "#484d50", // sin hover cuando está seleccionado
              },
            }}
          >
            <Checkbox
              checked={
                items.length === data.filter((d) => d !== "TODOS").length
              }
              indeterminate={
                items.length > 0 &&
                items.length < data.filter((d) => d !== "TODOS").length
              }
              sx={{
                color: "#fffcfc",
                "&.Mui-checked": {
                  color: "#cb9636",
                },
              }}
            />
            <ListItemText
              primary="TODOS"
              primaryTypographyProps={{
                fontSize: "12px",
                color: "#fffcfc",
              }}
            />
          </MenuItem>

          {data.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{
                fontSize: "10px",
                backgroundColor: "#484d50", // color base
                "&:hover": {
                  backgroundColor: "#484d50", // sin cambio en hover
                },
                "&.Mui-selected": {
                  backgroundColor: "#484d50", // sin color de selección
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "#484d50", // sin hover cuando está seleccionado
                },
              }}
            >
              <Checkbox
                checked={items.includes(name)}
                sx={{
                  color: "#fffcfc",
                  "&.Mui-checked": {
                    color: "#cb9636",
                  },
                }}
              />
              <ListItemText
                primary={name}
                primaryTypographyProps={{
                  fontSize: "12px",
                  color: "#fffcfc",
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
